export const baseURL =
  process.env.NODE_ENV === "development"
    ? "https://www.day1leadership.com"
    : "https://www.day1leadership.com";

// export const baseURL = "http://192.168.2.247:8080";

export const qiniuPrefix = "http://video.qiniu.collegedaily.com.cn/";

export const timeout = 300000;
export const ctype = "application/json";

export enum KEYS {
  TokenInfo = "token-back",
  LoginInfo = "userInfo-back",
}

//测试账号一，12345678
